import { Model } from "survey-core";
import { TextMarkdownEvent } from "survey-core/typings/survey-events-api";
import { EVENT_OPEN_LINK_WITHIN_PAGE } from "../../../../../constants/constants";
import { OnboardingFormModuleName } from "../../../types";
import { confirm } from "../../../../../components/modal/comfirm";
import { getI18n } from "react-i18next";
import { GlobalHelper } from "../../../../../utils/helpers/global-helper";
import { customMarked } from "../../../../../components/surveyjs/survey/survey.util";

export enum CustomType {
  Text = "text",
  Dropdown = "dropdown",
  Boolean = "boolean",
  Checkbox = "checkbox",
  RadioGroup = "radiogroup",
  Download = "download",
}

const funcprefix = "onBordingForm";

export const CustomFunctionName = {
  sendOtp: `${funcprefix}candidate-send-otp`,
  getOid: `${funcprefix}candidateGetOid`,
};
export type EndAdornment = {
  path?: string;
  triggerKey?: string;
  type?: string;
  btnText?: string;
  position?: "start" | "end";
  disabled?: boolean;
  actionParams?: Object;
};

export type SurveyTemplate = Model;

export const getTranslations = () => {
  return {
    the_data_has_been_saved: getI18n().t("Recruitment.onboarding_application_saved_successfully"),
    the_data_has_been_submitted: getI18n().t(
      "Recruitment.onboarding_application_submitted_successfully",
    ),
  };
};
export function findFirstPanelIndex(
  template: SurveyTemplate,
  module: OnboardingFormModuleName,
): number {
  let totalPanelCount = 0;
  let moduleFirstPanelIndex = -1;

  for (let page of template.pages) {
    if (page.name === module) {
      for (let j = 0; j < page.elements.length; j++) {
        const element = page.elements[j] as any;
        if (element.type === "panel") {
          moduleFirstPanelIndex = totalPanelCount + j;
          break;
        }
      }
      break;
    }

    for (let element of page.elements as any) {
      if (element.type === "panel") {
        totalPanelCount++;
      }
    }
  }

  return moduleFirstPanelIndex;
}

export function findPanelIndex(template: SurveyTemplate, sectionName: string): number {
  let panelIndex = 0;
  for (const page of template.pages) {
    for (const element of page.elements as any) {
      if (element.type === "panel" && element.name === sectionName) {
        return panelIndex;
      }
      panelIndex++;
    }
  }
  return -1;
}

export function regionPhoneValidate([region, number]: any[]): boolean {
  if (!number || !region) {
    return false;
  }
  const allRegions = require("./full-region-list.json");
  let regex = new RegExp(
    (Object as any).values(allRegions).find((regionItem: any) => regionItem.code === region)
      ?.regex ?? "^(\\d){5,20}$",
  );
  return regex.test(number);
}

// PHKL Custom -s
const isValidHkId = (hkId: string | undefined): boolean => {
  if (!hkId || hkId.length < 8 || hkId.length > 9) {
    return false;
  }
  const lsValidChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  const matches = new RegExp(/^[A-Z]{1,2}/).exec(hkId);

  if (matches?.length === 1) {
    const charPart = matches[0];
    const numPart = hkId.slice(charPart.length, -1);
    const checkDigit = hkId.charAt(hkId.length - 1);

    if (/^[\d]+$/.test(numPart)) {
      let checkSum: number;

      if (charPart.length == 1) {
        checkSum = 9 * 36 + 8 * (10 + lsValidChars.indexOf(charPart));
      } else {
        checkSum =
          9 * (10 + lsValidChars.indexOf(charPart.charAt(0))) +
          8 * (10 + lsValidChars.indexOf(charPart.charAt(1)));
      }

      for (let i = 0, j = 7; i < numPart.length; i++, j--) {
        checkSum += j * parseInt(numPart.charAt(i));
      }

      const remaining = checkSum % 11;

      let calCheckDigit: string;

      switch (remaining) {
        case 0: {
          calCheckDigit = '0';
          break;
        }
        case 1: {
          calCheckDigit = 'A';
          break;
        }
        default: {
          calCheckDigit = (11 - remaining).toString();
          break;
        }
      }

      return checkDigit == calCheckDigit;
    }
    return false;
  }
  return false;
};
// PHKL Custom -e

export function idNumValidate([idType, idNum]: any[]) {
  const validationRules =
    GlobalHelper.getIdTypeConfigs() ?? require("./identity-type-configs.json");
  if (!validationRules) return true;

  const rule: any = Object.values(validationRules).find((rule: any) => rule?.value === idType);

  if (!rule) {
    return true;
  }
  // PHKL Custom -s
  if (idType === "HKID" && !rule.regex) {
    if (!isValidHkId(idNum)) {
      return getI18n().t(rule.errMsg.replace(":", "."));
    }
  }
  // PHKL Custom -e

  const isValid = new RegExp(rule.regex).test(idNum);

  if (!isValid) {
    return getI18n().t(rule.errMsg.replace(":", "."));
  }

  return true;
}

function extractLinkContent(text: string) {
  const regex = /\[.*?\]\((.*?)\)/;
  const match = text.match(regex);

  if (match && match[1]) {
    return match[1];
  }

  return null;
}

export function markdownHandler(survey: Model, options: TextMarkdownEvent) {
  let str: string = options.text;
  if (str.includes("\n")) {
    str = str.replaceAll("\n", "<p />");
  }
  if (str.includes("[") && str.includes("]")) {
    // Convert Markdown to HTML
    str = customMarked.parse(str, { async: false });

    const url = extractLinkContent(options.text);
    const preset = (options.element as any).preset;
    //PHKL Custom -s
    if (url?.startsWith("http")) {
      str = `<span style="font-size: inherit" >${str}</span>`;
    } else {
      let onClickHandler = "";
      if (preset === "confirm_checkbox_with_detail") {
        onClickHandler = `
        event.preventDefault();
      `;
      } else {
        onClickHandler = `
        var target = event.target;
        if (target.tagName === 'A') {
          event.preventDefault();
          var customEvent = new CustomEvent('${EVENT_OPEN_LINK_WITHIN_PAGE}', {
            detail: { url: '${url}', questionName: '${options?.name}' },
            isTrusted: true
          });
          document.dispatchEvent(customEvent);
        }
      `;
      }
      str = `<span style="font-size: inherit" onclick="${onClickHandler}">${str}</span>`;
    }
    //PHKL Custom -e
  }
  // Set HTML markup to render
  options.html = str;
}

export function findSectionByIndex(data: any, index: number) {
  let total = 0;
  for (let i = 0; i < data.pages.length; i++) {
    let page = data.pages[i];
    let len = page.elements.length;
    if (total + len > index) {
      return page.elements[index - total]
        ? { ...page.elements[index - total], moduleName: page.name }
        : undefined;
    }
    total += len;
  }
}

export const confirmActionAsyncFunc = (message: string, resCallback: Function) => {
  confirm({
    message: message,
  }).then((result) => {
    resCallback(result.ok);
  });
  return true; //should return true
};
